import React, { useState } from "react";
import { useQuery, useQueryClient } from "@tanstack/react-query";
import { toast } from "sonner";
import api from "@/api";
export default function IncassiCantiere({ cantiereId }) {
  const qc = useQueryClient();
  const [data, setData] = useState(new Date().toLocaleDateString("en-CA"));
  const [importo, setImporto] = useState("");
  const [descrizione, setDescrizione] = useState("");
  const [fattura, setFattura] = useState("");
  const [modificaId, setModificaId] = useState(null);
  const [salvataggio, setSalvataggio] = useState(false);
  const { data: incassi = [], isLoading } = useQuery({
    queryKey: ["incassi", cantiereId],
    queryFn: () => api.get(`/cantieri/${cantiereId}/incassi`).then(r => r.data),
  });
  async function salvaIncasso(e) {
    e.preventDefault();
    if (salvataggio) return;
    const valore = Number(importo.replace(",", "."));
    if (!data || !Number.isFinite(valore) || valore <= 0) { toast.error("Controlla data e importo"); return; }
    setSalvataggio(true);
    try {
      const payload = { data, importo: valore, descrizione, riferimento_fattura: fattura };
      if (modificaId) await api.put(`/cantieri/${cantiereId}/incassi/${modificaId}`, payload);
      else await api.post(`/cantieri/${cantiereId}/incassi`, payload);
      await qc.invalidateQueries({ queryKey: ["incassi", cantiereId] });
      await qc.invalidateQueries({ queryKey: ["cantiere-econ", cantiereId] });
      toast.success("Incasso salvato");
      setImporto(""); setDescrizione(""); setFattura(""); setModificaId(null);
    } catch (err) { toast.error("Errore nel salvataggio dell incasso"); }
    finally { setSalvataggio(false); }
  }
  async function eliminaIncasso(incasso) {
    if (!window.confirm("Eliminare definitivamente questo incasso?")) return;
    try {
      await api.delete(`/cantieri/${cantiereId}/incassi/${incasso.incasso_id}`);
      await qc.invalidateQueries({ queryKey: ["incassi", cantiereId] });
      await qc.invalidateQueries({ queryKey: ["cantiere-econ", cantiereId] });
      toast.success("Incasso eliminato");
    } catch (err) { toast.error("Impossibile eliminare l incasso"); }
  }
  return (
    <section className="bg-white border border-slate-200 rounded p-5 space-y-4">
      <h3 className="text-lg font-bold">Gestione incassi del cantiere</h3>
      <p className="text-sm text-slate-600">Registra ogni pagamento ricevuto. Gli incassi determinano l avanzamento economico.</p>
      <form onSubmit={salvaIncasso} className="grid md:grid-cols-2 gap-3">
        <label className="text-sm font-medium">Data incasso<input type="date" required value={data} onChange={e => setData(e.target.value)} className="block w-full border rounded p-2 mt-1" /></label>
        <label className="text-sm font-medium">Importo ricevuto (€)<input type="number" min="0.01" step="0.01" required value={importo} onChange={e => setImporto(e.target.value)} className="block w-full border rounded p-2 mt-1" /></label>
        <label className="text-sm font-medium">Descrizione<input type="text" value={descrizione} onChange={e => setDescrizione(e.target.value)} placeholder="Es. Acconto lavori" className="block w-full border rounded p-2 mt-1" /></label>
        <label className="text-sm font-medium">Riferimento fattura (facoltativo)<input type="text" value={fattura} onChange={e => setFattura(e.target.value)} placeholder="Es. Fattura 15/2026" className="block w-full border rounded p-2 mt-1" /></label>
        <div className="md:col-span-2 flex gap-3">
          <button type="submit" disabled={salvataggio} className="bg-slate-900 text-white px-4 py-2 rounded disabled:opacity-50">{salvataggio ? "Salvataggio..." : modificaId ? "Salva modifica" : "Registra incasso"}</button>
          {modificaId && <button type="button" onClick={() => { setModificaId(null); setImporto(""); setDescrizione(""); setFattura(""); }} className="border px-4 py-2 rounded">Annulla modifica</button>}
        </div>
      </form>
      <div className="space-y-3">
        <h4 className="font-bold">Storico incassi</h4>
        {isLoading && <p>Caricamento incassi...</p>}
        {!isLoading && incassi.length === 0 && <p className="text-sm text-slate-500">Nessun incasso registrato.</p>}
        {incassi.map(incasso => (
          <div key={incasso.incasso_id} className="border rounded p-3 flex flex-wrap justify-between gap-3">
            <div>
              <div className="font-semibold">{Number(incasso.importo).toLocaleString("it-IT", { style: "currency", currency: "EUR" })}</div>
              <div className="text-sm">{incasso.data} - {incasso.descrizione || "Pagamento"}</div>
              {incasso.riferimento_fattura && <div className="text-xs text-slate-500">Fattura: {incasso.riferimento_fattura}</div>}
            </div>
            <div className="flex gap-2 items-center">
              <button type="button" onClick={() => { setModificaId(incasso.incasso_id); setData(incasso.data); setImporto(String(incasso.importo)); setDescrizione(incasso.descrizione || ""); setFattura(incasso.riferimento_fattura || ""); }} className="border px-3 py-1 rounded">Modifica</button>
              <button type="button" onClick={() => eliminaIncasso(incasso)} className="border border-red-300 text-red-700 px-3 py-1 rounded">Elimina</button>
            </div>
          </div>
        ))}
      </div>
    </section>
  );
}
